import { ButtonBase, DialogActions } from "@material-ui/core";
import React from "react";
import { MultipleTypesDocumentsUploader } from "../../../../../../../SharedComponents";
import {
  AutocompleteComponent,
  DatePickerComponent,
  DialogComponent,
  Inputs,
} from "../../../../../../../Components";
import { useTranslation } from "react-i18next";

function ViewAwardDialog({
  isOpen,
  activeAward,
  translationPath,
  setIsViewDialogOpen,
}) {
  const { t } = useTranslation(translationPath);
  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        titleText={t(`view-award`)}
        maxWidth="sm"
        dialogContent={
          <>
            <div className="create-user-award-dialog-wrapper">
              <div className="select-user-section-container">
                <AutocompleteComponent
                  idRef="selectUserForAwardRef"
                  labelValue={t("select-user")}
                  selectedValues={
                    {
                      fullName: activeAward?.userName,
                      usersId: activeAward?.usersId,
                    } || null
                  }
                  data={[
                    {
                      fullName: activeAward?.userName,
                      usersId: activeAward?.usersId,
                    },
                  ]}
                  displayLabel={(option) => option?.fullName || ""}
                  renderOption={(option) => option?.fullName || ""}
                  withoutSearchButton
                  multiple={false}
                  isDisabled={true}
                  parentTranslationPath={translationPath}
                  translationPath={""}
                  onChange={(e, newValue) => {}}
                  onInputKeyUp={(e) => {}}
                />
              </div>

              <Inputs
                idRef={"awardNameRef"}
                labelValue={"award-name"}
                type={"text"}
                value={activeAward.awardName || ""}
                onInputChanged={(e) => {}}
                isDisabled={true}
                translationPath={""}
                parentTranslationPath={translationPath}
              />

              <DatePickerComponent
                type="date"
                labelValue="award-date"
                value={activeAward.awardDate || null}
                isDisabled={true}
                onDateChanged={(value) => {}}
                translationPath={""}
                parentTranslationPath={translationPath}
              />

              <MultipleTypesDocumentsUploader
                idRef="awardCertificateUploaderRef"
                initUploadedFiles={
                  activeAward?.awardDocuments
                    .filter((item) => item.isCertificate === true)
                    .map((item) => {
                      return {
                        awardDocumentId: item.awardDocumentId,
                        uuid: item.fileId || item.uuid,
                        fileName: item.documentName || item.fileName,
                        documentLink: item.documentLink || item.url,
                        isCertificate: item.isCertificate,
                      };
                    }) || []
                }
                labelValue="award-certificate"
                accept="application/pdf, image/png, image/jpg"
                uploadedChanged={(files) => {}}
                multiple={false}
                isOpenGallery
                viewUploadedFilesCount={false}
                openGallery
                isDocuments
                isDisabled={true}
                chipHandler={(value) => () => {}}
                translationPath={""}
                parentTranslationPath={translationPath}
              />

              <MultipleTypesDocumentsUploader
                idRef="awardCertificateUploaderRef"
                labelValue="supporting-documents"
                initUploadedFiles={
                  activeAward?.awardDocuments
                    .filter((item) => item.isCertificate === false)
                    .map((item) => {
                      return {
                        awardDocumentId: item.awardDocumentId,
                        uuid: item.fileId || item.uuid,
                        fileName: item.documentName || item.fileName,
                        documentLink: item.documentLink || item.url,
                        isCertificate: item.isCertificate,
                      };
                    }) || []
                }
                multiple={true}
                isOpenGallery
                viewUploadedFilesCount={false}
                openGallery
                isDocuments
                isDisabled={true}
                uploadedChanged={(files) => {}}
                chipHandler={(value) => () => {}}
                translationPath={""}
                parentTranslationPath={translationPath}
              />
            </div>

            <DialogActions>
              <ButtonBase
                onClick={() => {
                  setIsViewDialogOpen(false);
                }}
                className={`btns theme-solid bg-cancel`}
              >
                {t(`cancel`)}
              </ButtonBase>
              <ButtonBase
                className={`btns theme-solid`}
                onClick={() => {
                  setIsViewDialogOpen(false);
                }}
              >
                {t(`confirm`)}
              </ButtonBase>
            </DialogActions>
          </>
        }
        translationPath={""}
        parentTranslationPath={translationPath}
      />
    </>
  );
}

export default ViewAwardDialog;
